import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';

import { ILoggedInUserViewModel } from '../../../../model/common.model';
import { ExistentUserNamePipe } from '../../pipes/existent-user-name.pipe';
import { CurrentUserProfileHttpService } from '@services/current-user-profile-http.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-sidebar-user-info',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, MatTooltipModule, ExistentUserNamePipe, MatIconModule],
  templateUrl: './sidebar-user-info.component.html',
  styleUrls: ['./sidebar-user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarUserInfoComponent implements OnInit, OnDestroy {
  @Input() currentUser: ILoggedInUserViewModel | null = null;
  @Input() isSwitchRole: boolean = false;

  private subscriptions: Subscription[] = [];
  user: ILoggedInUserViewModel;
  isCurrentUserPicture = false;
  currentUserPicture = 'assets/img/v2/general/no-avatar.svg';
  userAbbreviation = '';

  constructor(
    private readonly currentUserHttpService: CurrentUserProfileHttpService,
    private cd: ChangeDetectorRef,
  ) {
    this.getCurrentUserPicture();
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.userAbbreviation = this.user.firstName.charAt(0) + this.user.lastName.charAt(0);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  getCurrentUserPicture(): void {
    const currentUserPictureUrlSub = this.currentUserHttpService.currentUserPictureUrl$.subscribe({
      next: (url: string) => {
        if (url) {
          this.isCurrentUserPicture = true;
          this.currentUserPicture = url;
          this.cd.markForCheck();
        }
      },
    });
    this.subscriptions.push(currentUserPictureUrlSub);

    const getCurrentUserPictureSub = this.currentUserHttpService.getCurrentUserPicture().subscribe();
    this.subscriptions.push(getCurrentUserPictureSub);
  }
}
